import React from "react";
import { Fade, Zoom } from "react-reveal";
import Swing from "react-reveal/Swing";

const Project = ({ item }) => {
  return (
    <div
      key={item.id}
      className="flex flex-col items-center  shadow-lg bg-gray-800 text-center p-4 rounded-full group"
    >
      <Swing>
        <div className="mb-8">
          <img
            className="rounded-2xl h-60 w-72 object-cover overflow-hidden group-hover:scale-110 transition duration-700 "
            src={item.image}
            alt=""
          />
        </div>
      </Swing>
      <p className="capitalize text-accent text-sm mb-3">{item.category}</p>
      <Fade left>
        <h3 className="text-2xl font-semibold capitalize mb-3">{item.name}</h3>
      </Fade>
      <Fade right>
        <p className="text-base max-w-md">{`${item.description.slice(
          0,
          100
        )}...`}</p>
      </Fade>
      <Zoom>
        <div className="">
          <a
            href={item?.githubClient}
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="bg-accent hover:bg-rose-700 my-5 text-white px-7 py-2 mx-2 rounded">
              Github Client
            </button>
          </a>
          <a
            href={item?.githubServer}
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="bg-accent hover:bg-rose-700 my-5 text-white px-7 py-2 mx-2 rounded">
              Github Server
            </button>
          </a>
          <a href={item?.LiveLink} target="_blank" rel="noopener noreferrer">
            <button className="bg-accent hover:bg-rose-700 my-5 text-white px-7 py-2 mx-2 rounded">
              Live Link
            </button>
          </a>
        </div>
      </Zoom>
    </div>
  );
};

export default Project;
